/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { JobOutcomeTrigger } from "./JobOutcomeTrigger";
import { JobOutcomeNext } from "./JobOutcomeNext";
export const JobOutcome = core.serialization.object({
    acknowledge: core.serialization.boolean().optional(),
    trigger: JobOutcomeTrigger.optional(),
    buttonText: core.serialization.string().optional(),
    next: JobOutcomeNext.optional(),
    heading: core.serialization.string().optional(),
    message: core.serialization.string().optional(),
    hideDefaultButton: core.serialization.boolean().optional(),
});
